<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex.mt-2(xs12)

                    // Coupon ID field
                    v-text-field(
                        :error-messages="errors.collect('id')"
                        :data-vv-as="$t('fields.id')"
                        :label="$t('fields.id')"
                        name="id"
                        v-model="model.id"
                        v-validate="'required|alpha_dash'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Discount type selection
                    v-select(
                        :items="$t('selection.discountType')"
                        :label="$t('fields.discountType')"
                        name="discountType"
                        v-model="discountType"
                        append-icon="expand_more"
                        outline
                    )

                v-flex(xs12 sm6 v-if="showPercentOff")

                    // Percent off field
                    v-text-field(
                        :error-messages="errors.collect('percent_off')"
                        :data-vv-as="$t('fields.percentOff')"
                        :label="$t('fields.percentOff')"
                        name="percent_off"
                        key="percent_off"
                        v-model="model.percent_off"
                        v-validate="'required|decimal:2'"
                        outline
                    )

                v-flex(xs12 sm6 v-else)

                    // Ammount off field
                    v-text-field(
                        :error-messages="errors.collect('amount_off')"
                        :data-vv-as="$t('fields.amountOff')"
                        :label="$t('fields.amountOff')"
                        name="amount_off"
                        key="amount_off"
                        v-model="model.amount_off"
                        v-validate="'required|decimal:2'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Max redemptions field
                    v-text-field(
                        :error-messages="errors.collect('max_redemptions')"
                        :data-vv-as="$t('fields.maxRedemptions')"
                        :label="$t('fields.maxRedemptions')"
                        name="max_redemptions"
                        v-model="model.max_redemptions"
                        v-validate="'numeric'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Redeem by picker
                    div
                        date-picker(
                            :label="$t('fields.redeemBy')"
                            :datePickerCallback="startDateCallback"
                        )

                v-flex(xs12 sm6)

                    // Discount duration selection
                    v-select(
                        :items="$t('selection.duration')"
                        :label="$t('fields.duration')"
                        name="duration"
                        v-model="model.duration"
                        append-icon="expand_more"
                        outline
                    )

                v-flex(xs12 sm6 v-if="model.duration === 'repeating'")

                    // Duration in Monthes
                    v-text-field(
                        :error-messages="errors.collect('duration_in_months')"
                        :data-vv-as="$t('fields.durationInMonths')"
                        :label="$t('fields.durationInMonths')"
                        name="duration_in_months"
                        v-model="model.duration_in_months"
                        v-validate="'required|numeric'"
                        outline
                    )
</template>

<script>
    import DatePicker from '~components/Picker/DatePicker';
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';
    import dayjs from 'dayjs';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            DatePicker,
            TitleComponent: Title
        },
        computed: {
            ...mapFields('coupons', {
                model: 'coupon'
            })
        },
        data() {
            return {
                discountType: 'percent_off',
                showPercentOff: true
            };
        },
        watch: {
            discountType(val) {
                if (val === 'percent_off') return (this.showPercentOff = true);

                return (this.showPercentOff = false);
            }
        },
        methods: {
            ...mapActions('coupons', ['create']),

            /**
             * Create Business account on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                // Call store action Create Business account
                this.create();
            },

            startDateCallback(date) {
                this.model.redeem_by = dayjs(date).unix().toString();
            }
        }
    };
</script>
